import { render, staticRenderFns } from "./LightingMenu.vue?vue&type=template&id=b4b73616"
import script from "./LightingMenu.vue?vue&type=script&lang=js"
export * from "./LightingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports